import api from "../../services/axiosHeader.js";
import {sources} from "../../../api/entryPoint";

export const state = {
    source: [],
    isLoading: true,
}

export const mutations = {
    SET_SOURCE(state, newValue) {
        state.source = newValue;
    },
    SET_IS_LOADING(state, payload) {
        state.isLoading = payload;
    },
}
export const getters = {
    getSource(state) {
        return state.source;
    },
    getIsLoading(state) {
        return state.isLoading;
    },
}

export const actions = {
    // List all sources
    listSource({commit}) {
        api.get(sources).then((res) => {
            commit('SET_SOURCE', res.data)
        }).catch((error) => {
            console.log(error);
        });
    },
    // Get sources id
    getSourceId({commit}, id) {
        api.get(sources + '/' + id)
            .then((res) => {
                commit('SET_SOURCE', res.data)
            }).catch((error) => {
            console.log(error);
        });
    },
    /* create source */
    createSource({commit}, payload) {
        let data = JSON.stringify(payload);
        commit('SET_IS_LOADING', true);
        api.post(sources, data)
            .then((res) => {
                if (res) {
                    commit('SET_IS_LOADING', false);
                }
            }).catch((error) => {
            console.log(error);
        });
    },
    /* edit  source */
    editSource({commit}, payload) {
        let id = payload.id;
        delete payload.id;
        let data = JSON.stringify(payload);
        commit('SET_IS_LOADING', true);
        api.post(sources + '/' + id, data)
            .then((res) => {
                if (res) {
                    commit('SET_IS_LOADING', false);
                }
            }).catch((error) => {
            console.log(error);
        });
    },
    /* delete source */
    deleteSource({commit}, id) {
        return api.delete(sources + '/' + id);
    },
}